@import '@hevoio/hevo-ui-toolkit/styles/variables';

.sqlEditorWrapper {
  border-radius: $border-radius-md;
  border: solid $border-width $divider-color;
  position: relative;
  overflow: hidden;
}

.sqlEditor {
  height: 300px;
}
